import { createActionCreator } from '../../utils/helpers';

import { fundingSearchMatch, fundingSearchOffer, fundingSearchOffers } from './types';

export const requestFundingSearchOffers = createActionCreator(
  fundingSearchOffers.request,
  'fundingSearchId',
);
export const requestFundingSearchOffersSuccess = createActionCreator(
  fundingSearchOffers.success,
  'fundingSearchId',
  'response',
);
export const requestFundingSearchOffersFailure = createActionCreator(
  fundingSearchOffers.failure,
  'fundingSearchId',
  'error',
);

export const requestFundingSearchOffer = createActionCreator(
  fundingSearchOffer.request,
  'offerId',
  'matchId',
);
export const requestFundingSearchOfferSuccess = createActionCreator(
  fundingSearchOffer.success,
  'offerId',
  'response',
);
export const requestFundingSearchOfferFailure = createActionCreator(
  fundingSearchOffer.failure,
  'offerId',
  'error',
);

export const requestFundingSearchMatch = createActionCreator(fundingSearchMatch.request, 'matchId');
export const requestFundingSearchMatchSuccess = createActionCreator(
  fundingSearchMatch.success,
  'matchId',
  'response',
);
export const requestFundingSearchMatchFailure = createActionCreator(
  fundingSearchMatch.failure,
  'matchId',
  'error',
);
